import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { ThirdPartyLoansStore } from '../stores/thirdPartyLoansStore';

export const useThirdPartyLoanStore = () =>
  useContext<{
    thirdPartyLoansStore: ThirdPartyLoansStore;
  }>(StoreContext);
